import { render, staticRenderFns } from "./GiftBoxCampaignsAnalytics.vue?vue&type=template&id=453484a8&"
import script from "./GiftBoxCampaignsAnalytics.vue?vue&type=script&lang=js&"
export * from "./GiftBoxCampaignsAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports